import { render, staticRenderFns } from "./WootSnoozedModal.vue?vue&type=template&id=4d66997b&"
import script from "./WootSnoozedModal.vue?vue&type=script&lang=js&"
export * from "./WootSnoozedModal.vue?vue&type=script&lang=js&"
import style0 from "./WootSnoozedModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports